module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CategoryBox":{"configureButtonText":"Začít konfigurovat","status":{"stock":"Skladem","custom":"Na objednávku","delivery":"Doba dodání: 3-4 týdny výroba +1 týden doprava"}}}}')
  delete Component.options._Ctor
}
